import { render, staticRenderFns } from "./header.vue?vue&type=template&id=52b0ede8&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=52b0ede8&prod&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=52b0ede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0ede8",
  null
  
)

export default component.exports